import { Typography } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import { FC } from 'react';

import UnstyledLink from 'components/UnstyledLink';
import { Card } from 'containers/WelcomePage/Item/index.styled';

interface ItemProps {
  to: string;
  label: string;
  image: string;
}

const Item:FC<ItemProps> = ({
  label,
  to,
  image,
}) => (
  <UnstyledLink to={to}>
    <Card>
      <CardMedia
        sx={{
          width: '100%',
          height: '200px',
          borderRadius: '20px',
          mb: 1.8,
        }}
        component="img"
        src={image}
        alt={label}
      />
      <Typography variant="h6" fontWeight={700} textAlign="center">
        {label}
      </Typography>
    </Card>
  </UnstyledLink>
);

export default Item;
